import omit from 'lodash-es/omit';
import { getLastThreadMessage } from './get-last-thread-message';
var getLastMessage = function (chatThread) {
    var normalizedChatThread = omit(chatThread, ['__EMPTY_ID__']);
    // Pick the last saved message
    var lastSavedMessage = normalizedChatThread[Object.keys(normalizedChatThread)[0]];
    for (var _i = 0, _a = Object.keys(normalizedChatThread); _i < _a.length; _i++) {
        var key = _a[_i];
        var chatThreadMessage = normalizedChatThread[key];
        if (chatThreadMessage.timestamp > lastSavedMessage.timestamp) {
            lastSavedMessage = chatThreadMessage;
        }
    }
    return lastSavedMessage;
};
var getFinalLastMessage = function (threadMessages) {
    var filteredThreadArray = threadMessages.filter(function (value) {
        if (value === null || value === void 0 ? void 0 : value.timestamp)
            return value;
    });
    if (filteredThreadArray.length < 1)
        return;
    var lastMessage = filteredThreadArray[0];
    for (var index = 0; index < filteredThreadArray.length; index++) {
        var threadMsg = filteredThreadArray[index];
        if ((threadMsg === null || threadMsg === void 0 ? void 0 : threadMsg.timestamp) > (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.timestamp)) {
            lastMessage = threadMsg;
        }
    }
    return lastMessage;
};
export var getMeta = function (state, threadId, filterFn) {
    var lastThreadMessage = getLastThreadMessage(state, filterFn)(threadId);
    return (lastThreadMessage === null || lastThreadMessage === void 0 ? void 0 : lastThreadMessage.meta) || {};
};
